import type { ListBuilderList } from '../../../types';
import { createClientColumnsNoLifecycle } from '../columns';
import {
	createClientKanbanConfig,
	DEFAULT_LIST_REQUIRED_FIELDS,
} from '../shared';

/**
 * Open Orders list configuration
 * Clients with open orders
 */
export const defaultClientsOpenOrdersList: ListBuilderList = {
	id: 'default-clients-open-orders',
	cacheTTL: 600000,
	name: 'Open Orders',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	filterRules: {
		salespeople: {
			defaultValue: [],
			additionalValues: [
				{
					values: [{ id: 'ME', label: 'Me' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
					applyAsDefault: false,
				},
				{
					values: [{ id: 'null', label: 'Unassigned' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{
								type: 'rule',
								action: 'clients:view:unassigned',
								negated: false,
							},
						],
					},
					applyAsDefault: false,
				},
			],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
			boundedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
		orderSalesStatus: {
			defaultValue: [
				{
					id: 'open-orders',
					label: 'Open Orders',
				},
			],
		},
	},
	columns: createClientColumnsNoLifecycle(),
	description: 'Clients with open orders',
	defaultSortId: 'column-client-name-asc',
	requiredFields: DEFAULT_LIST_REQUIRED_FIELDS,
	sortOrder: 6,
	kanbanConfig: createClientKanbanConfig(),
};
